import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxSessionViewComponent } from '@go-modules/components/feedback-session/session-view/session-view.component';

// TODO - remove when routesConfig ngx STAB-1182
export const ngxSessionViewModule = angular.module('ngxSessionViewModule', [])
	.directive('ngxSessionView', downgradeComponent({ component: NgxSessionViewComponent }))
	.name;
